import React from "react";
import { StyledLoader } from "./styles";

const Loader = ({ isLoading }) => {
  return <StyledLoader spinning={isLoading} size="large" fullscreen={true} />;
};

export default Loader;
